/* tslint:disable:no-bitwise */

import { Performance } from '../services/performance.service';

export class GuidGenerator {
    /**
     * Creates a RFC4122 version 4 compliant GUID:
     * http://www.ietf.org/rfc/rfc4122.txt
     */
    public static createGuid(): string {
        let timestamp = Performance.now();

        const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
            const rand = (timestamp + Math.random() * 16) % 16 | 0;
            timestamp = Math.floor(timestamp / 16);
            return (char === 'x' ? rand : (rand & 0x3 | 0x8)).toString(16);
        });

        return guid;
    }
}
